.audioControls {
  width: 23px;
  height: 23px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 6px;
  cursor: pointer;
  
  svg {
    @include themify($themes) {
      color: themed("neutral-primary");
    }
  }
}

.audioPlayer {
  display: flex;
  flex-direction: column;
  
  input[type='range'] {
    height: 5px;
    -webkit-appearance: none;
    width: 100%;
    border-radius: 8px;
    background: #3b7677;
    transition: background 0.2s ease;
    cursor: pointer;
    
    &::-webkit-slider-thumb {
      background-color: #82C0F7;
      width: 12px;
      height: 12px;
      border-radius: 50%;
      cursor: pointer;
      -webkit-appearance: none;
    }
  }
}

.audioPlayerTop {
  display: flex;
  align-items: center;
  width: 100%;
}

.audioTime {
  font-size: 11px;
  user-select: none;

  @include themify($themes) {
    color: themed("neutral-primary");
  }
}
